<template lang="pug">
  .changes-row(v-if='!isMobileScreen')
    .field(v-if='!isMobileScreen')
      .field-item
        p( v-if="isRelationshipType" ) {{ relationshipType }}
        p {{ getField }}
      p.field-item {{ getValueOld }}
      p.field-item(:class="newValueRemoved") {{ getValueNew }}

  .modification-row(v-else)
    .label-block
      p.bold-text {{ getDate | dateShortFormat }}
    .value-item
      el-collapse(v-model="activeName" accordion)
        el-collapse-item(:name="getDate | dateFormat")
          template( slot="title" )
            p.field-title Field:
            p.field-value {{ getField }}
          .values
            .old-value
              p.cell Old value:
              p {{ getValueOld }}
            .new-value
              p.cell New value:
              p {{ getValueNew }}

</template>

<script>
import { mapGetters, mapState, } from 'vuex'
import { timeFormat, } from '@/store/helpers.js'
import moment from 'moment'

export default {
  name: 'RecordchangessRow',
  props: {
    item: {
      type: [ Object, Array, ],
      required: true,
    },
  },
  data () {
    return {
      activeName: '1',
      relationshipType: '',
      types: [
        {
          id: 'IS_ULTIMATELY_CONSOLIDATED_BY',
          value: 'ULTIMATE',
        },
        {
          id: 'ULTIMATE_ACCOUNTING_CONSOLIDATION_PARENT',
          value: 'ULTIMATE',
        },
        {
          id: 'IS_DIRECTLY_CONSOLIDATED_BY',
          value: 'DIRECT',
        },
        {
          id: 'DIRECT_ACCOUNTING_CONSOLIDATION_PARENT',
          value: 'DIRECT',
        },
        {
          id: 'IS_INTERNATIONAL_BRANCH_OF',
          value: 'BRANCH',
        },
      ],
    }
  },
  computed: {
    getDate () {
      return this.item.date ? this.item.date : null
    },
    getField () {
      if (!this.filters) return null
      const [ data, ] = this.filters.filter((f) => f.xpath === this.item.field)
      return data && data.label
        ? data.label
        : this.item.field
    },
    getValueNew () {
      if (moment(this.item.valueNew, moment.ISO_8601, true).isValid()) {
        return timeFormat(this.item.valueNew)
      }

      return this.item.valueNew
        ? this.item.valueNew
        : 'removed'
    },
    newValueRemoved () {
      return this.item.valueNew
        ? {}
        : { 'field-item-removed': true, }
    },
    getValueOld () {
      if (moment(this.item.valueOld, moment.ISO_8601, true).isValid()) {
        return timeFormat(this.item.valueOld)
      }

      return this.item.valueOld
        ? this.item.valueOld
        : null
    },
    getRelationshipType () {
      if (this.item.context && this.item.context.relationshipType) {
        return this.item.context.relationshipType
      }
      if (this.item.context && this.item.context.exceptionCategory) {
        return this.item.context.exceptionCategory
      }
      return null
    },
    isRelationshipType () {
      return this.item.context && (this.item.context.relationshipType || this.item.context.exceptionCategory)
    },

    ...mapGetters([ 'isMobileScreen', ]),
    ...mapState('search', [ 'filters', ]),
  },
  mounted () {
    this.parsedRelationshipType()
  },
  methods: {
    parseStringBySeparator (str, separator, comp) {
      return str.split(separator).join(comp)
    },
    parsedRelationshipType () {
      this.types.forEach((item) => {
        if (item.id === this.getRelationshipType) {
          this.relationshipType = item.value
        }
      })

      if (!this.relationshipType) this.relationshipType = this.getRelationshipType
    },
  },
}
</script>

<style lang="stylus" scoped>
   @import "../../../assets/styles/variables.styl"
   .changes-row
     line-height 1.5
     margin-bottom: 2px
     .field
       width 100%
       display flex
       .field-item
         word-break: break-word
         padding: 15px 20px
         background-color: $default-color-light-2
         color: $default-color-bold-1
         width 35%
         &:first-child
           color: $default-color
           font-weight: 600
           font-size: 90%
           width 30%
           margin-right 10px
         &:last-child
           margin-left 2px
         &-removed
           color: $default-color-middle

  .cell, .field-title
    color: $default-color
    font-weight: 600
    display: block
    font-size: 90%

  .field-value
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 65vw;

  .field-title
    margin-right: 5px
    margin-left: 20px

   .bold-text
    color $default-color-bold
    font-weight 600

  .n-a
    color: $default-color-middle

  .modification-row
    display: grid
    grid-template-columns: 1fr
    grid-column-gap: 10px
    margin-bottom: 2px
    width: 100%
    line-height 1.5

    .label-block
      padding 15px 20px
      background-color: $default-color-light-2
    .value-item
      display: grid
      grid-column-gap: 2px
      grid-template-columns: minmax(200px, 310px) 1fr
      .values
        line-height: 1.5;
        padding: 15px 20px;
        background-color: $default-color-light-2
        color $default-color-bold-1
        font-weight 500
        display: grid

        .old-value
          margin-bottom: 10px
        .old-value, .new-value
          word-break: break-word


  @media (max-width: $laptop)
    .cell
      margin-bottom: 10px
    .modification-row
      .value-item
        grid-template-columns: 1fr
        .cell
          margin-bottom: 0
          padding-top: 2px
        .values
          display: grid
          grid-template-columns: 1fr
          grid-column-gap: 10px
          .old-value
            margin-bottom: 0
          .old-value, .new-value
            display: grid
            grid-template-columns: 80px 1fr
            grid-gap: 10px

  @media (max-width: 860px)
    .modification-row
      .value-item
        .values
          grid-template-columns: 1fr


  @media (max-width: $tablet)
   .cell
     margin-bottom: 5px

   .modification-row
     font-size: 90%;
     grid-template-columns: 1fr
     border-bottom: 1px solid #d8d8d8;
     margin-bottom: 0
     .label-block
       background-color $white-color
     .value-item
        .cell
          margin-bottom: 5px
        .values
          background-color: $white-color
          .old-value
            margin-bottom: 10px
          .old-value, .new-value
            grid-template-columns: 1fr

</style>



// WEBPACK FOOTER //
// src/components/record-details/modifications/RecordChangesRow.vue